import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from "lodash";
import {CSVLink} from 'react-csv';
import toCsv from '../../utils/toCsv';
import QueryString from 'query-string';

import LIVE_REPORTING_CONTROLLER from '../../controllers/liveReporting';
import GLOBAL_FILTER_CONTROLLER from '../../controllers/globalFilter';
import LANGUAGES_CONTROLLER from '../../controllers/languages';
import { TransmissionStatusResultEnum} from '../../utils/enums';
import ComponentUtil from '../../utils/componentUtil';
import { sanitizeCsvData } from '../../utils/csvSanitizer';
import {FIELDS as GLOBAL_FILTER_PANEL_FIELDS} from '../filter/GlobalFilterPanel';
import TransmissionStatusFilterPanel from './TransmissionStatusFilterPanel';
import TransmissionDetails from './TransmissionDetails';

import Logger, { LOG_LEVELS } from '../../utils/logger';

const log = new Logger('VIEW_TRANSMISSIONS_PAGE', LOG_LEVELS.DEBUG);

const PAGE_INTERNAL_IDS = [
    GLOBAL_FILTER_PANEL_FIELDS.PARAM_COMPANY_ID,
    GLOBAL_FILTER_PANEL_FIELDS.PARAM_COMPANY_CODE,
    GLOBAL_FILTER_PANEL_FIELDS.PARAM_MONTH,
    GLOBAL_FILTER_PANEL_FIELDS.PARAM_YEAR,
    GLOBAL_FILTER_PANEL_FIELDS.PARAM_COUNTRY_CODE,
    "defaultMonth",
    "defaultYear"
];

function parseQueryParams(string) {
    log.debug('parseQueryParams: string: ', string);
    const originalQp = QueryString.parse(string, { arrayFormat: 'index' });
    const decodedQp = _.each(originalQp, (value, key) => { return decodeURIComponent(value); });
    log.debug('parseQueryParams: ', originalQp, decodedQp);
    return decodedQp;
}


function stringifyQueryParams(qp) {
    const encodedQp = _.each(qp, (value, key) => { return encodeURIComponent(value); });
    log.debug('sqp: ', qp, encodedQp);
    return QueryString.stringify(encodedQp, { arrayFormat: 'index' });
}

function getTransmissionStatsEnum(parsedQueryParams) {
    const queryParams = parsedQueryParams || {};
    let showFailed = queryParams.showFailed || false;
    let showSuccessful = queryParams.showSuccessful || false;

    if (showFailed === 'true' && showSuccessful === 'true') {
        return TransmissionStatusResultEnum.UNKNOWN;
    }
    else if (showFailed === 'true') {
        return TransmissionStatusResultEnum.ERROR;
    }
    else if (showSuccessful === 'true') {
        return TransmissionStatusResultEnum.DONE;
    }
    else {
        return TransmissionStatusResultEnum.UNKNOWN;
    }
}

class Page extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            isGenericVatCodeSelected: props.isGenericVatCodeSelected,
            isTabToggle : false,
            pages: -1,
            loading: true,
            pageSize: 500,
            count: 0,
            page: 1,
            sorted: [],
            filtered: []
        };
        this.fetchData = this.fetchData.bind(this);
        this.filterSelectionHandler = this.filterSelectionHandler.bind(this);
        this.onFilterApply = this.onFilterApply.bind(this);
    }

    filterSelectionHandler(keyValuePairs) {
        log.debug('filterSelectionHandler() Key value pairs: ', keyValuePairs);
        const key = Object.keys(keyValuePairs)[0];
        const values = Object.values(keyValuePairs)[0];
        let parsedQueryParams = parseQueryParams(this.props.location.search);
        let newQueryParams = parsedQueryParams;
        log.debug('filterSelectionHandler() parsedQueryParams: ', parsedQueryParams);
        if (values === '' || values === 'false') {
            //const keys = Object.keys(keyValuePairs);
            delete parsedQueryParams[key];
            newQueryParams = parsedQueryParams;
            this.props.history.push({
                search: stringifyQueryParams(parsedQueryParams)
            });
        } else {
            newQueryParams = Object.assign({}, parsedQueryParams, keyValuePairs);
            log.debug('filterSelectionHandler() newQueryParams:', newQueryParams);
            this.props.history.push({
                search: stringifyQueryParams(newQueryParams)
            });
        }        
    }
    
    onFilterApply(selection) {
        log.debug("onFilterApply(): event: " + selection);
        const pageSize = Object.is(this.state.pageSize, NaN) ? 500 : this.state.pageSize;                
        const startAt = this.state.page * pageSize;
        const params = {            
            startAt: startAt === 0 ? 1 : startAt,
            count: pageSize,
            startDate: selection.startDate,
            endDate: selection.endDate,
            status: getTransmissionStatsEnum(selection),
            taxNumber: selection.legalEntity,
            invoiceNumber: selection.invoiceNumber,
        };
        if(!_.isEmpty(selection)) {
            this.props.onPageLoad(params);
        }
        let urlParams = Object.assign({}, selection);        
        PAGE_INTERNAL_IDS.forEach(key => delete urlParams[key]);                
        ComponentUtil.updateUrlParams(this.props.location, this.props.history, urlParams);
    }



    /**
     * Whenever the table model changes, or the user sorts or changes pages, this method gets called and passed the current table model.
     * 
     * @param {any} state 
     * @param {any} instance 
     * @memberof Page
     */
    fetchData(state, instance) {
        // You can set the `loading` prop of the table to true to use the built-in one or show you're own loading bar if you want.
        const pageSize = Object.is(state.pageSize, NaN) ? 500 : state.pageSize;
        const page = Object.is(state.page, NaN) ? 0 : state.page;
        const startAt = page * pageSize;
        this.setState({
            loading: true,
            pageSize: pageSize,
            page: page,
            sorted: state.sorted,
            filtered: state.filtered
        });
        const parsedQueryParams = parseQueryParams(this.props.location.search);
        const params = {
            startAt: startAt === 0 ? 1 : startAt,
            count: pageSize,
            startDate: parsedQueryParams.startDate,
            endDate: parsedQueryParams.endDate,
            status: getTransmissionStatsEnum(parsedQueryParams),
            taxNumber: parsedQueryParams.legalEntity || '',
            invoiceNumber: parsedQueryParams.invoiceNumber || '',
        };
        //Only make request for non-sorting or non-filter update
        let requestData = _.isEqual(this.state.filtered, state.filtered) && _.isEqual(this.state.sorted, state.sorted);
        if (requestData) {
            if (!_.isEmpty(parsedQueryParams)) {
                this.props.onPageLoad(params);
            } else {
                this.setState({
                    loading: false
                });    
            }
        } else {
            this.setState({
                loading: false
            });
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        log.debug("componentWillReceiveProps():  nextProps: ", nextProps);
        if (this.props.hulrTransmissions !== nextProps.hulrTransmissions) {
            log.debug("componentWillReceiveProps(): Updated trasmission data: ", nextProps.hulrTransmissions);
            let hulrTransmissions = nextProps.hulrTransmissions || [];
            let totalCount = (nextProps.hulrTransmissions && nextProps.hulrTransmissions.totalCount) || hulrTransmissions.length;
            let pageCount =  this.state.pageSize === 0 ? totalCount : Math.ceil(totalCount / this.state.pageSize);
            let tablePaginationNewState = {
                loading: false,
                count: totalCount,
                pages: pageCount
            };
            log.debug("componentWillReceiveProps(): tablePaginationNewState: ", tablePaginationNewState);
            this.setState(tablePaginationNewState);
        }
    }

    componentDidMount() {
        log.debug('componentDidMount()');
        log.clearAllDictionaryErrors();
        let parsedQueryParams = QueryString.parse(this.props.location.search);
        log.debug('componentDidMount(): parsedQueryParams: ',parsedQueryParams);
        let globalFilterSelection = GLOBAL_FILTER_CONTROLLER.getAll();
        log.debug('componentDidMount(): globalFilterSelection: ',globalFilterSelection);
        let filterSelection = Object.assign({}, parsedQueryParams, globalFilterSelection);
        if(!_.isEmpty(filterSelection)) {
          PAGE_INTERNAL_IDS.forEach(key => delete filterSelection[key]);
          ComponentUtil.updateUrlParams(this.props.location, this.props.history, Object.assign({
            showFailed: true,
            showSuccessful: true
          },filterSelection)); 
        } 
    }

    render() {
        log.debug('render(): ', this.props);
        log.debug('render(): location.search:', this.props.location.search);
        let parsedQueryParams = parseQueryParams(this.props.location.search);
        log.debug('render(): queryParams', parsedQueryParams);
        let isRequestVersion20 = false;
        let hulrTransmissions = (this.props.hulrTransmissions && this.props.hulrTransmissions.hulrTransmissions) || [];
        let transmissions = hulrTransmissions.map((entry) => {
            //Data from data supplied
            let info = entry.dataSuppliedJSON || {};
            let invoiceHead = {};
            let invoiceAppearance = '';
            isRequestVersion20 = info.invoiceOperations && info.invoiceOperations.invoiceOperation &&
                                    info.invoiceOperations.invoiceOperation.Invoice != undefined ? false : true;
            if(isRequestVersion20) {
              invoiceHead = (info.invoiceOperations &&
                   info.invoiceOperations.invoiceOperation &&
                   info.invoiceOperations.invoiceOperation.InvoiceData &&
                   info.invoiceOperations.invoiceOperation.InvoiceData.invoiceMain &&
                   info.invoiceOperations.invoiceOperation.InvoiceData.invoiceMain.invoice &&
                  info.invoiceOperations.invoiceOperation.InvoiceData.invoiceMain.invoice.invoiceHead
               ) || {};
              invoiceAppearance = (invoiceHead.invoiceDetail && invoiceHead.invoiceDetail.invoiceAppearance) || '';
           }
           else
           {
              invoiceHead = (   info.invoiceOperations &&
                   info.invoiceOperations.invoiceOperation &&
                   info.invoiceOperations.invoiceOperation.Invoice &&
                   info.invoiceOperations.invoiceOperation.Invoice.invoiceExchange &&
                   info.invoiceOperations.invoiceOperation.Invoice.invoiceExchange.invoiceHead
               ) || {};

               invoiceAppearance = (invoiceHead.invoiceData && invoiceHead.invoiceData.invoiceAppearance) || '';
           }
            const supplierName = (invoiceHead.supplierInfo && invoiceHead.supplierInfo.supplierName) || '';
            const customerName = (invoiceHead.customerInfo && invoiceHead.customerInfo.customerName) || '';
            //Data from response data
            const responseJSON = entry.submissionResponseJSON || {};
            const message = entry.message || (responseJSON.isErrorResponse ? (responseJSON.GeneralErrorResponse &&
                                                            responseJSON.GeneralErrorResponse.result &&
                                                            responseJSON.GeneralErrorResponse.result.message
                                                        ):'');

            let dataSentDecoded = (entry.dataSentExtended && entry.dataSentExtended.decoded && entry.dataSentExtended.decoded.xml ) || "";            
            return {
                "SupplierTaxNumber": entry.taxNumber || '',
                "Supplier": supplierName,
                "InvoiceNumber": entry.invoiceNumber || '',
                "InvoiceDate": entry.invoiceDate || '',
                "InvoiceAppearance": invoiceAppearance,
                "CustomerName": customerName,
                "Operation": entry.operation || '',
                "Result": entry.submissionResult || LANGUAGES_CONTROLLER.format(this.props.languages, 'viewTransmission_Pending'),
                "ErrorCode": entry.errorCode,
                "Message": message,
                "TransactionId": entry.transactionID|| '',
                "GUID": entry.guid || '',
                "DataSupplied": entry.dataSupplied || '',
                "DataSentEncoded": entry.dataSentEncoded || '',
                "DataSentDecoded": dataSentDecoded,
                "SubmissionResponse": entry.submissionResponse
            };
        });

        let filteredTransmissions = transmissions;
        if (this.state.filtered && this.state.filtered.length) {
            filteredTransmissions = this.state.filtered.reduce((filteredSoFar, nextFilter) => {
                return filteredSoFar.filter(row => {
                    return (row[nextFilter.id] + "").includes(nextFilter.value);
                });
            }, filteredTransmissions);
        }

        let sortedTransmissions = filteredTransmissions;
        if (this.state.sorted && this.state.sorted.length) {
            sortedTransmissions = _.orderBy(
                filteredTransmissions,
                this.state.sorted.map(sort => {
                    return row => {
                        if (row[sort.id] === null || row[sort.id] === null) {
                            return -Infinity;
                        }
                        return typeof row[sort.id] === "string" ?
                            row[sort.id].toLowerCase() :
                            row[sort.id];
                    };
                }),
                this.state.sorted.map(d => (d.desc ? "desc" : "asc"))
            );
        }

        let csv = toCsv(sanitizeCsvData(sortedTransmissions));
        return (
            <s-container>
                <div className="content-area">
                    <h1>{LANGUAGES_CONTROLLER.format(this.props.languages, 'viewTransmission_TransmissionStatus')}</h1> 
                    <TransmissionStatusFilterPanel
                        selectionHandler={this.filterSelectionHandler}                        
                        onApply={this.onFilterApply}
                        filterOption={parsedQueryParams}
                    />
                    <TransmissionDetails
                        pages={this.state.pages}
                        data={sortedTransmissions}
                        loading={this.state.loading}
                        onFetchData={this.fetchData}
                        pageSizeOptions={[500, 1000, 2000, 5000, 10000]}
                        defaultPageSize={this.state.pageSize}
                    />

                    {sortedTransmissions >= 0 ? (
                        <div></div>
                    ) : (
                        <CSVLink 
                            data={csv} 
                            filename={'TransmissionStatus.csv'}
                            className="button primary mb20"
                            disabled={sortedTransmissions && sortedTransmissions.length > 0 ? "" : true}
                        >
                            {LANGUAGES_CONTROLLER.format(this.props.languages, 'viewTransmission_ExportToCSV')}
                        </CSVLink>
                    )}

                    
                </div>
                <div className="clear"></div>
            </s-container>
        );
    }
}


function mapStateToProps(state) {
    const stateProps = {
        languages: state.languages,
        hulrTransmissions: (state.liveReporting && state.liveReporting.hulrTransmissions) || []
    };

    return stateProps;
}

function mapDispatchersToProps(dispatch) {
    const dispatchProps = {};
    dispatchProps.onPageLoad = (params) => {
        dispatch(LIVE_REPORTING_CONTROLLER.doLoadHULRTransmissions(params));
    };
    return dispatchProps;
}

export default connect(mapStateToProps, mapDispatchersToProps)(Page);
